import { render, staticRenderFns } from "./MissingTranslationItem.vue?vue&type=template&id=25be2530&scoped=true&"
import script from "./MissingTranslationItem.vue?vue&type=script&lang=js&"
export * from "./MissingTranslationItem.vue?vue&type=script&lang=js&"
import style0 from "./MissingTranslationItem.vue?vue&type=style&index=0&id=25be2530&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25be2530",
  null
  
)

export default component.exports